<template>
    <div class="header">
        <div class="content">
            <div class="left">
                <img class="logo" v-if="showDefaultIcon" :src="headerLogo" width="178" height="45">
                <img class="logo" v-else :src="webInfo.web_header_logo" width="178" height="45">
                <p class="home" v-if="showHome" @click="goHome">首页</p>
            </div>
            <div class="right">
                <slot></slot>
                <template v-if="isLogin">
                    <span class="username">{{ username }}</span>
                    <el-badge :value="unreadCount" v-if="unreadCount!=0">
                    <el-dropdown @command="handleCommand">
                        <img class="user-avator" :src="userAvator" width="30" height="30">
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">个人中心</el-dropdown-item>
                            <el-dropdown-item command="2">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    </el-badge>
                    <el-dropdown @command="handleCommand" v-else>
                        <img class="user-avator" :src="userAvator" width="30" height="30">
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">个人中心</el-dropdown-item>
                            <el-dropdown-item command="2">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
                <template v-else>
                    <el-button class="login-btn" type="text" @click="handleLogin">登录</el-button>
                    <el-button class="register" type="primary" @click="handleRegister">免费注册</el-button>
                </template>
            </div>
        </div>
        <!-- 登录 -->
        <Login ref="loginModal" @updateLoginState="changeLoginState" />
    </div>
</template>
<script>
    import Login from '../login.vue'
    import { mapGetters } from 'vuex'
    import GLOBAL_CONFIG from '../../../config/index'

    export default {
        components: {
            Login
        },
        data() {
            return {
                isLogin: false,
                username: '',
                userAvator: '',
                checkTokenTimer: null,
                unreadCount:0,
                headerLogo: require(`@/assets/mofang/${GLOBAL_CONFIG.logo}`)
            }
        },
        computed: {
            ...mapGetters({
                webInfo: 'getWebInfo'
            }),
            showHome() {
                return this.$route.name !== 'Home'
            },
            showDefaultIcon() {
                return !this.webInfo.web_wx_account &&
                !this.webInfo.web_header_icon &&
                !this.webInfo.web_header_logo &&
                !this.webInfo.web_bottom_logo
            }
        },
        created(){
            this.checkIsLogin()
            this.getCourseHomeworkRead()
        },
        mounted(){
        },
        methods: {
            getCourseHomeworkRead(){
                this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead').then(res=>{
                console.log('[<-- res作业未读数 -->]',res);
                if (res.data.code==200) {
                    this.unreadCount=res.data.data
                }    
                })
            },
            goHome() {
                this.$router.push({ name: 'index' })
            },
            handleLogin() {
                this.$refs.loginModal.open()
            },
            handleRegister() {
                this.$refs.loginModal.open()
                this.$refs.loginModal.v_zhuce()
            },
            handleCommand(type) {
                if(type === '1') {
                    this.$router.push({ path: '/zhanghu' })
                } else if (type === '2') {
                    this.handleOutLogin()
                }
            },
            changeLoginState() {
                this.getUserInfo()
            },
            getUserInfo() {
                this.$axios.post('/user/index/getUserInfo').then((res) => {
                    if (res.data.code === 200) {
                        this.isLogin = true
                        localStorage.setItem('tengface_fans_id', res.data.data.id)
                        this.username = res.data.data.nick_name
                        this.userAvator = res.data.data.icon
                        this.$emit('updateUserInfo', { username: this.username, userAvator: this.userAvator })
                        if (res.data.data.org_id) {
                            localStorage.setItem('tengface_org_id', res.data.data.org_id)
                            this.$store.commit('user/setOrgID',res.data.data.org_id)
                        }
                        this.$store.commit('user/setRemark',res.data.data.stu_note)
                        this.$store.commit('user/setFansId',res.data.data.id)
                    }
                })
            },
            // 检查是否为登陆状态
            checkIsLogin() {
                const token = localStorage.getItem('token')
                if (token) {
                    this.isLogin = true
                    this.getUserInfo()
                    clearInterval(this.checkTokenTimer)
                    this.checkTokenTimer = setInterval(() => {
                        this.checkTokenValid()
                    }, 10000)
                }
            },
            checkTokenValid() {
                this.$axios.post('/user/index/checkToken').then((res) => {
                    if (res.data.code === 100068 || res.data.code === 100067) {
                        this.$message({
                            message: 'token失效重新登录',
                            type: 'error',
                        })
                        setTimeout(() => {
                            this.handleOutLogin()
                        }, 1000)
                    } else if(res.data.code == 10000) {
                        this.$confirm('该机构已被禁用，直播相关功能限制使用', '提示', {
                            showClose: false,
                            showConfirmButton: false,
                            showCancelButton: false,
                            closeOnClickModal: false,
                            type: 'error'
                        })
                    }
                })
            },
            // 退出登陆
            handleOutLogin() {
                localStorage.removeItem('token')
                location.reload()
            }
        },
        beforeDestroy(){
            this.checkTokenTimer && clearInterval(this.checkTokenTimer)
        },
    }
</script>
<style lang='scss' scoped>
.header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 68px;
    background-color: #ffffff;
    .content {
        display: flex;
        justify-content: space-between;
        width: 1260px;
        margin: auto;
        .left {
            display: flex;
            align-items: center;
            .home {
                margin-left: 50px;
                margin-left: 50px;
                font-size: 16px;
                color: #20242f;
                cursor: pointer;
            }
        }
        .right {
            display: flex;
            align-items: center;
            .login-btn {
                color: #1872ED;
                margin-left: 40px;
            }
            .register {
                width: 100px;
                height: 36px;
                border: none;
                padding: 0;
                margin-left: 20px;
                border-radius: 49px;
                background: linear-gradient(110deg,#73aaff 0%, #0053ff 100%);
            }
            .username {
                color: #20242F;
                font-size: 14px;
                margin: 0 20px;
            }
            .user-avator {
                border-radius: 50%;
            }
        }
    }
}
</style>